import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';
import { FlowManagerService } from '../../../shared/services/flowmanager.service';

@Component({
  selector: 'pending-app',
  template: require('./pending-app.component.html'),
  styles: [require('./pending-app.component.scss')]
})
export class PendingAppComponent extends BaseRoute {

  requestId = '';

  constructor(injector: Injector, flowManager: FlowManagerService) {
    super(injector);
    this.flowManager = flowManager;
    this.loadingNext = false;
    this.documentPend = false; // false - show generic || true - show document upload
  }

  ngOnInit() {
    this.requestId = this.flowManager.requestId;
    this.appActions.setData('stepUserIsOn', 0);

    if (this.requestId && this.flowManager.accountStatus === 'DOCUMENTS_REQUESTED') {
      this.documentPend = true;
    }

    if (this.focusItem) {
      this.focusItem.nativeElement.focus();
    }
  }

  goToAccounts() {
    if (this.flowManager.isAuthed && this.flowManager.getAccountType() === 'select-custodial') {
      this.flowManager.ssoToAlly();
    } else {
      this.appProxy.getAccountsLink(res => {
        this.flowManager.canUnload = true;
        window.location.href = res.url;
      });
    }
  }
}
